import styled from "styled-components";

export const ProductWarrantyHistoryContainerStyled = styled.div`
  padding: 20px 16px 40px 16px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .product_warranty_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .member_type_layout {
      padding: 24px 24px 0px 24px;
    }
    .product_warranty_title {
      padding: 0px 24.5px 24.5px 24.5px;
      text-align: center;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
    .sub_title {
      padding-left: 26px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
    .product_warranty_list {
      .product_item_wrap {
        border-bottom: 0.5px solid ${({ theme }) => theme.COLORS.GRAY_15};
        padding-bottom: 14px;
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .btn_wrap {
      margin: auto;
      margin-top: 30px;
      max-width: 167px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 20px 18px 104px 18px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
